import type { ReactNode } from "react";
import * as React from "react";
import { createContext, useContext, useEffect, useState } from "react";

import type { StorageClient } from "./types";

const consentManagementPolicyClientContext =
  createContext<StorageClient | null>(null);

export const useStorageClient = () =>
  useContext(consentManagementPolicyClientContext);

interface StorageClientProviderProps {
  client: StorageClient;
  children: ReactNode;
}

export const StorageClientProvider = ({
  client,
  children,
}: StorageClientProviderProps) => {
  const [storageClient, setStorageClient] = useState(client);
  useEffect(() => {
    if (storageClient.status === "idle") {
      storageClient.init().then(setStorageClient);
    }
  }, [storageClient, setStorageClient]);

  return (
    <consentManagementPolicyClientContext.Provider value={storageClient}>
      {children}
    </consentManagementPolicyClientContext.Provider>
  );
};
